export default "__VITE_ASSET__acaVYFh5__"